import { useEffect } from "react";
import { createPortal } from "react-dom";

interface ModalProps {
  children: React.ReactNode;
  onClose?: () => void;
  closeOnOverlay?: boolean; // 👈 NUEVO
}

const Modal: React.FC<ModalProps> = ({
  children,
  onClose,
  closeOnOverlay = true, // 👈 por defecto SÍ se puede cerrar
}) => {

  // 🔒 Bloquea el scroll del body cuando el modal está abierto
  useEffect(() => {
    const originalOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";

    return () => {
      document.body.style.overflow = originalOverflow;
    };
  }, []);

  return createPortal(
    <div className="fixed inset-0 z-[9999] flex items-center justify-center">

      {/* 🔹 Fondo oscuro */}
      <div
        className="absolute inset-0 bg-black/50 backdrop-blur-sm"
        onClick={closeOnOverlay ? onClose : undefined} // 👈 CONTROL AQUÍ
      />

      {/* 🔹 Contenido del modal */}
      <div className="relative z-[10000]">
        {children}
      </div>

    </div>,
    document.body
  );
};

export default Modal;